import { render, staticRenderFns } from "./FooterSpNavigationIr.vue?vue&type=template&id=1a4288f1&scoped=true"
import script from "./FooterSpNavigationIr.vue?vue&type=script&lang=js"
export * from "./FooterSpNavigationIr.vue?vue&type=script&lang=js"
import style0 from "./FooterSpNavigationIr.vue?vue&type=style&index=0&id=1a4288f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4288f1",
  null
  
)

export default component.exports